import type { TCores } from '@/types/cores'
import { CoresEnum, CoresPorStatus } from '@/types/cores'
import type { TProdutoTipoLegendaStatusEnum } from '@/types/produto'

export const corPorStatus = (status: TProdutoTipoLegendaStatusEnum, shade: TCores): { fill: string; text: string } =>
  CoresPorStatus[status][shade]

export function parseTonalidade(value: unknown): TCores {
  return typeof value === 'string' && Object.values(CoresEnum).includes(value) ? (value as TCores) : 'Claro'
}
